<template>
    <a
        :href="isFileCanBeDownloaded ? newsInfo.file.link : newsInfo.detailPageUrl"
        :download="!!isFileCanBeDownloaded ? newsInfo.name : null"
        class="news-card col-tablet-12"
        :target="isFileCanBeDownloaded ? '_blank' : '_self'"
    >
        <div class="news-card__content col-default-8 col-tablet-12">
            <date-block class="news-card__date" :date="newsDate" size="s" />
            <z-caption class="news-card__title" tag="h3">
                <span v-html="newsInfo.name"></span>
                 <span v-if="isFileCanBeDownloaded" class="news-card__title-tag">PDF</span>
            </z-caption>

            <div v-if="newsInfo.category || newsInfo.type.value" class="news-card__tags">
                <tag
                    v-if="
                        newsInfo.type.value === 'Пресс-релиз' ||
                            newsInfo.type.value === 'Press Release'
                    "
                    class="news-card__tags-item"
                    theme="peach"
                >
                    {{ newsInfo.type.value }}
                </tag>
                <tag v-else class="news-card__tags-item" theme="gray">
                    {{ newsInfo.type.value }}
                </tag>
                <tag
                    class="news-card__tags-item"
                    theme="gray"
                    v-for="(tag, index) in newsInfo.category"
                    :key="index"
                >
                    {{ tag.value }}
                </tag>
            </div>
        </div>
        <img
            v-if="newsInfo.previewPicture && newsInfo.previewPicture.link"
            class="news-card__img col-default-2 hide-me--tablet"
            :src="newsInfo.previewPicture.link || ''"
            :alt="newsInfo.previewPicture.name || ''"
        />
        <img
            v-else
            class="news-card__img col-default-2 col-tablet-4 hide-me--tablet"
            src="/images/news/dummyimage.webp"
            alt=""
        />
    </a>
</template>

<script>
import moment from 'moment'

export default {
    name: 'news-card',
    props: {
        newsInfo: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        newsDate () {
            const date = moment.unix(this.newsInfo.activeFrom).format('MM/DD/YYYY')
            return date
        },
        isFileCanBeDownloaded () {
            return this.newsInfo.file.link && !this.newsInfo.detailText
        }
    }
}
</script>

<style lang="scss" scoped>
.news-card {
    width: 100%;
    background-color: $token-colors-white;
    margin-bottom: 40px;
    padding-bottom: 40px;
    border-bottom: 1px solid $token-colors-tertiary-15;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    text-decoration: none;
    justify-content: space-between;
    align-items: flex-start;

    &:first-child {
        padding-top: 40px;
        border-top: 1px solid $token-colors-tertiary-15;

         @include breakpoint(mobile) {
            padding-top: 19px;
        }
    }

    &:hover {
        .news-card__title {
            color: $token-colors-link-hover;
        }
    }

    @include breakpoint(mobile) {
        margin-bottom: 19px;
        padding-bottom: $token-spacers-s;
    }

    &__date {
        margin-bottom: $token-spacers-xs;

        .date-block__container:before {
            z-index: 1;
        }

        .date-block__date {
            z-index: 2;
        }
    }

    &__title {
        font-size: 28px !important;
        line-height: 130% !important;
        color: $token-colors-link-default !important;
        margin-bottom: $token-spacers-xs !important;
        font-weight: 500 !important;
        position: relative;
        padding-right: 60px !important;

        @include breakpoint(tablet) {
            font-size: 20px;
        }

        @include breakpoint(mobile) {
            font-size: 18px;
        }

        &-tag {
            margin-left: 10px;
            background: $token-colors-tertiary-15;
            border-radius: 6px;
            padding: 2px 10px;
            color: $token-colors-link-default;
            font-size: 14px;
            line-height: 150%;
            font-weight: 500;
            vertical-align: middle;
        }
    }

    &__tags {
        display: flex;
        flex-wrap: wrap;

        &-item:not(:last-child) {
            margin-right: 12px;
        }

        &-item {
            margin-bottom: 12px;
        }
    }

    &__img {
        max-width: 249px;
        max-height: 253px;
        object-fit: cover;
        margin-left: $token-spacers-s;
        @include breakpoint(tablet) {
            margin: o auto;
        }
    }
}
</style>
